import React from 'react'
import { Link } from 'react-router-dom'
/* REDUX */
import { connect } from 'react-redux'
import { loginUser } from '../../actions/auth'
import { Field, reduxForm } from 'redux-form'

const form = reduxForm({
	form: 'login',
})

class LoginForm extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			error: '',
			
		}
		this.handleFormSubmit = this.handleFormSubmit.bind(this)
	}
	
	handleFormSubmit() {
		const formProps = this.props.formValues
		if (!formProps || !formProps.email || !formProps.password) {
			console.log("set State")
			this.setState({
				error: 'Please complete all fields'
			})
			return
		}
		this.props.loginUser(formProps, this.props.onClose);
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({
			error: nextProps.errorMessage
		})
	}
	
	handleKeyPress(e) {
		if(e.key == 'Enter'){
			this.handleFormSubmit()
		}
	}
	
	render() {
		
		const { switchAuth } = this.props
		
		return (
			<form>
				<h4 className="title">Sign in</h4>
				<div className="command-wrapper">
					<span className="welcome">New user?</span>
					<span className="action">
						<a className="modal-link" onClick={ switchAuth }>Create Account</a>
					</span>
				</div>
				<p className="median">or continue to login</p>
				<span className="error">{this.state.error}</span>
				<label>E-mail</label>
				<Field name="email" className="form-control" component="input" type="text" onKeyPress={ this.handleKeyPress.bind(this) } />
				<label>Password</label>
				<label className="forgot" tabIndex="-1"><Link className="modal-link" to="/reset" onClick={ this.props.onClose } tabIndex="-1">Forgot Password?</Link></label>
				<Field name="password" className="form-control" component="input" type="password" onKeyPress={ this.handleKeyPress.bind(this) } />
				<button type="button" className="btn btn-login" onClick={ this.handleFormSubmit }>Sign in</button>
			</form>
		)
	}
}

const mapStateToProps = (state) => {
	const formState = state.form.login || {}
	const formValues = formState.values
	return {
		formValues,
		errorMessage: state.auth.error,
	    message: state.auth.message,
	    authenticated: state.auth.authenticated
	}
}

export default connect(mapStateToProps, {loginUser})(form(LoginForm))


// WEBPACK FOOTER //
// ./src/components/Modals/LoginForm.js